import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  CircularProgress,
  Switch,
  FormControlLabel,
  MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../DataLayouts/Header";
import toast from "react-hot-toast";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import { MAIN_URL } from "../../../Configurations/Urls";
import { fetchPayrollComponentTypes, fetchPayrollLoan, fetchPayrollLoanTypes } from "../../../Apis/Payroll";
import { fetchOrganizationEmployee } from "../../../Apis/Employee-api";

function PayrollLoanTransactionForm({ mode }) {
  const { id } = useParams();
  const { userData } = useAuthStore();
  const org = userData?.organization;

  const MAX_INCREMENT = 999999999.99;
  const [formData, setFormData] = useState({
    organization_person_id: "",
    organization_payroll_loan_id: "",
    transaction_date: "",
    transaction_type: "",
    amount: "",
    payment_mode: "",
    reference_no: "",
    remarks: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(mode === "edit");
  const [btnLoading, setbtnLoading] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [loan, setLoan]=useState([])
  let navigate = useNavigate();

  useEffect(() => {
    if (org?.organization_id) {
      fetchOrganizationEmployee(org.organization_id)
        .then((data) => {
          // fetchOrganizationEmployee already returns an array
          const employeeArray = Array.isArray(data) ? data : (data?.employees || data?.data || []);
          setEmployee(employeeArray);
          console.log("Employee data loaded:", employeeArray);
        })
        .catch((err) => {
          console.error("Error fetching employees:", err);
          setEmployee([]);
          toast.error(err.message || "Failed to fetch employee data");
        });
    }
  }, [org?.organization_id]);


  useEffect(() => {
    if (org?.organization_id) {
      fetchPayrollLoan(org.organization_id)
        .then((data) => {
          setLoan(data?.payroll || []);
        })
        .catch((err) => {
          console.error("Error fetching loans:", err);
          setLoan([]);
          toast.error(err.message || "Failed to fetch loan data");
        });
    }
  }, [org?.organization_id]);
  useEffect(() => {
    let getdataById = async () => {
      const response = await axios.get(
        `${MAIN_URL}/api/organizations/${org.organization_id}/payroll-loan-transaction/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      let a = response?.data?.payroll;
      setFormData(a);
      setLoading(false);
    };
    if (mode === "edit" && id) {
      setLoading(true);
      getdataById();
    }
  }, [mode, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_person_id) {
      errors.organization_person_id = "Person is required.";
    }

    if (!formData.transaction_date) {
      errors.transaction_date = "Transaction Date is required.";
    }

    setFormErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setbtnLoading(true);

    try {
      if (mode === "edit") {
        await axios.put(
          `${MAIN_URL}/api/organizations/${org.organization_id}/payroll-loan-transaction/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      } else {
        await axios.post(
          `${MAIN_URL}/api/organizations/${org.organization_id}/payroll-loan-transaction`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }
      toast.success(
        mode === "edit"
          ? "Payroll Loan Transaction updated!"
          : "Payroll Loan  Transaction created!"
      );
      setFormErrors({});
      navigate(-1);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 422) {
        const validationErrors = err.response.data.errors || {};
        setFormErrors(validationErrors);
        const errorMessages = Object.values(validationErrors)
          .map((arr) => arr[0])
          .join(" ");
        toast.error(errorMessages || "Validation failed.");
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setbtnLoading(false);
    }
  };

  return (
    
      <Header
        mode={mode}
        updateMessage={"Payroll loan Transactions"}
        addMessage={"Payroll Loan Transactions"}
        homeLink={"/payroll/loan-transactions"}
        homeText={"Payroll Loans Transactions"}
        onSubmit={handleSubmit}
        loading={loading}
        btnLoading={btnLoading}>
      {loading ? (
        <Grid container spacing={2}>
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <TextField
                  select
                  fullWidth
                  label="Person Name/ID"
                  name="organization_person_id"
                  value={formData?.organization_person_id}
                  onChange={handleChange}
                  error={!!formErrors.organization_person_id}
                  helperText={formErrors.organization_person_id}
                  required
                >
                  {employee?.map((option) => {
                    const fullName =
                      `${option?.person_full_name || option?.name || ""} -- ${option?.person_code || option?.employee_code || option?.organization_person_id || ""}`.trim();
                    return (
                      <MenuItem
                        key={option?.organization_person_id}
                        value={option?.organization_person_id}
                      >
                        {fullName ? fullName : option?.organization_person_id}
                      </MenuItem>
);
                  })}
                </TextField>

                <TextField
                  select
                  fullWidth
                  label="Payroll Loan"
                  name="organization_payroll_loan_id"
                  value={formData.organization_payroll_loan_id || ""}
                  onChange={handleChange}
                  error={!!formErrors.organization_payroll_loan_id}
                  helperText={formErrors.organization_payroll_loan_id}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  {loan?.map((option) => (
                    <MenuItem
                      key={option.organization_payroll_loan_id}
                      value={option.organization_payroll_loan_id}
                    >
                      {option?.loan_type?.loan_type_name || `Loan #${option.organization_payroll_loan_id}`}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  fullWidth
                  label="Transaction Date"
                  name="transaction_date"
                  type="date"
                  value={formData.transaction_date || ""}
                  onChange={handleChange}
                  error={!!formErrors.transaction_date}
                  helperText={formErrors.transaction_date}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

                <TextField
                  select
                  fullWidth
                  label="Transaction Type"
                  name="transaction_type"
                  value={formData.transaction_type || ""}
                  onChange={handleChange}
                  error={!!formErrors.transaction_type}
                  helperText={formErrors.transaction_type}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="Disbursement">Disbursement</MenuItem>
                  <MenuItem value="Installment">Installment</MenuItem>
                  <MenuItem value="Prepayment">Prepayment</MenuItem>
                  <MenuItem value="Refund">Refund</MenuItem>
                  <MenuItem value="Waiver">Waiver</MenuItem>
                </TextField>

                <TextField
                  fullWidth
                  label="Amount"
                  name="amount"
                  type="number"
                  value={formData?.amount || ""}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (/^\d*\.?\d*$/.test(value)) {
                      if (value === "" || Number(value) <= MAX_INCREMENT) {
                        handleChange(e);
                      } else {
                        e.target.value = MAX_INCREMENT;
                        handleChange(e);
                      }
                    }
                  }}
                  error={!!formErrors.amount}
                  helperText={formErrors.amount}
                  inputProps={{
                    min: 0,
                    max: MAX_INCREMENT,
                    step: 0.01,
                  }}
                />

                <TextField
                  select
                  fullWidth
                  label="Payment Mode"
                  name="payment_mode"
                  value={formData.payment_mode || ""}
                  onChange={handleChange}
                  error={!!formErrors.payment_mode}
                  helperText={formErrors.payment_mode}
                >
                  <MenuItem value="">
                    <em>None</em>
                  </MenuItem>
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Cheque">Cheque</MenuItem>
                  <MenuItem value="Bank Transfer">Bank Transfer</MenuItem>
                  <MenuItem value="SalaryDeduction">Salary Deduction</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </TextField>

                <TextField
                  fullWidth
                  label="Reference No"
                  name="reference_no"
                  value={formData.reference_no || ""}
                  onChange={handleChange}
                  error={!!formErrors.reference_no}
                  helperText={formErrors.reference_no}
                  inputProps={{ maxLength: 255 }}
                />

                <TextField
                  fullWidth
                  label="Remarks"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  error={!!formErrors.remarks}
                  helperText={formErrors.remarks}
                  inputProps={{ maxLength: 255 }}
                  multiline
                  rows={6}
                />

                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={handleSubmit}
                  disabled={loading || btnLoading || mode === "view"}
                  sx={{
                    borderRadius: 2,
                    minWidth: 120,
                    textTransform: "capitalize",
                    fontWeight: 500,
                  }}
                >
                  {loading || btnLoading ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : mode === "edit" ? (
                    "Submit"
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Grid>

              {mode === "edit" && (
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={() => navigate(-1)}
                    sx={{
                      borderRadius: 2,
                      minWidth: 120,
                      textTransform: "capitalize",
                      fontWeight: 500,
                      mt: 2,
                      backgroundColor: "#1976d2",
                      "&:hover": { backgroundColor: "#115293" },
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}
            </Paper>
          </Grid>
        </Grid>
      )}
    
    </Header>
  );
}

export default PayrollLoanTransactionForm;
